import { useMemo } from 'react';

import { UseProjectScorecardsProvider } from 'components/widgets/ProjectScorecards/ProjectScorecards.provider';
import { serializeScoreCardsData } from 'components/widgets/ProjectScorecards/projectScorecards.utils';

interface Props {
    api: UseProjectScorecardsProvider['api'];
}

export const useProjectScorecardsLogic = ({ api }: Props) => {
    const scoreCardsTableData = useMemo(() => {
        if (api.getProjectScoreCardsSummary.instance.data) {
            return serializeScoreCardsData(api.getProjectScoreCardsSummary?.instance?.data?.componentsList);
        }
        return [];
    }, [api.getProjectScoreCardsSummary.instance.data]);

    return {
        logic: {
            scoreCardsTableData,
        },
    };
};
